import Image from "next/image"

type ResponsiveImageProps = {
  image?: string
  alt?: string
  objectPosition?: string
  sizes?: string
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down"
}

const ResponsiveImage = ({
  image,
  alt,
  objectPosition,
  sizes = "(max-width: 768px) 100vw, 50vw",
  objectFit = "contain",
}: ResponsiveImageProps) => {
  // Safety check: return null if image is not provided
  if (!image) {
    return null
  }

  // Check if image is SVG (has .svg extension)
  // SVG files don't need @3x variants since they're vector graphics
  const isSvg = image.toLowerCase().endsWith(".svg")

  // Check if path already has a non-svg extension (e.g., .png, .jpg, .webp)
  // New uploads from API return paths without extensions, but some existing data might have full paths
  const hasExtension = /\.(png|jpg|jpeg|webp)$/i.test(image)

  // Only append @3x.png if it's not SVG and doesn't already have an extension
  let src = isSvg || hasExtension ? image : `${image}@3x.png`

  // Ensure path is absolute (starts with /) if it's a local path
  if (!src.startsWith("/") && !src.startsWith("http")) {
    src = `/${src}`
  }

  return (
    <Image
      fill
      src={src}
      alt={alt || ""}
      sizes={sizes}
      style={{
        objectFit: objectFit,
        objectPosition: objectPosition || "center",
      }}
    />
  )
}

export default ResponsiveImage
